var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.showProgressBar
      ? _c(
          "div",
          {
            staticClass: "progress-bar-wrapper",
            style: { backgroundColor: _vm.primaryColor },
          },
          [
            _c("div", { staticClass: "text" }, [
              _vm._v(_vm._s(_vm.messages.progressMessage)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "progress-bar" }, [
              _c("span", {
                staticClass: "progress",
                style: { width: _vm.progress, background: _vm.primaryColor },
              }),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }